/*
 *
 * WithRoute constants
 *
 */

export const HASH_ADD = 'app/WithRoute/HASH_ADD';
export const HASH_CLEAR = 'app/WithRoute/HASH_CLEAR';
export const HASH_DELETE = 'app/WithRoute/HASH_DELETE';
